import {Component} from '@angular/core';
import {Api} from "../../providers/api";
import {Events} from 'ionic-angular';
import { NavController, NavParams ,AlertController,ModalController,ToastController} from 'ionic-angular';
import * as _ from "underscore";
import {WebstoreUserAddPage} from "../webstore-user-add/webstore-user-add";
import {WebstoreUserAddPopup} from "../webstore-user-add-popup/webstore-user-add-popup";
import {CartManager} from "../../providers/cart-manager";
import {MsgManager} from "../../providers/msg-manager";
import {SpinnerDialog} from "ionic-native";
import {LoginPage} from '../login/login';
import {GVLogger} from "../../services/gv-logger";



@Component({
  selector: 'webstore-users',
  templateUrl: 'webstore-users.html'
})
export class WebstoreUsersPage{

	private showList: boolean;
	private customers:any = [];
	private searchQuery:any;



	constructor(
		private api:Api,
		private nav:NavController,
		private modalController:ModalController,
		private cartManager:CartManager,
		private msgManager:MsgManager,
		private toastController:ToastController,
		private events:Events,
    private gVLogger: GVLogger
		){
		this.showList = true;
	    this.searchQuery = " ";

	    this.events.subscribe("webstoreUserUpdated",()=>{
	    	this.gVLogger.log("Event: webstoreUserUpdated");
	    	setTimeout(()=>{
	    		this.customers = [];
	    		this.searchCustomersLazy(this.searchQuery,0);
	    	},200);
	    });

	    this.events.publish("webstoreUserUpdated");
	}



	searchCustomersLazy(searchQuery,itemCount){

		return new Promise(resolve=>{



		  	var url = "customers/searchForUser/"+searchQuery+"/"+itemCount;
		    this.gVLogger.log(url);
		    // get list items of a category as sample
		    this.api.get(url).map(res => res.json())
		    .subscribe(data => {

		   if(data.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
            resolve(true);
            this.nav.setRoot(LoginPage);
          }else if(data.status == "200"){
          	 let temp = this.customers;

		      if(!(typeof data === 'undefined') && data ){
		          if (data.data && data.data.constructor === Array) {

		          } else {
		            data.data = [];
		          }
		        }else{
		          data = { data: []};
		        }


		     	 this.gVLogger.log(data.data);
			      for(let cust of data.data){

			        temp.push(cust);
			      }

			      this.customers  = this.arrayUnique(temp);
			      //this.customers  = temp;
			      this.gVLogger.log(this.customers);
			      resolve(true);
	          }


		      });
	    });
}


doInfinite(infiniteScroll){
     this.searchCustomersLazy(this.searchQuery,this.customers.length).then(()=>{
     	infiniteScroll.complete();
     });
}

searchThroughItems(ev: any){
    // Reset items back to all of the items
    // this.initializeCustomers();
    this.gVLogger.log(ev.target.value);
    // Show the results
    this.showList = true;
// set val to the value of the searchbar
    let val = ev.target.value;

    if(ev.target.value!=""){
      this.searchQuery = val;
      this.customers = [];
      this.searchCustomersLazy(this.searchQuery,0);
      }else{
        this.searchQuery = " ";
      this.customers = [];
      this.searchCustomersLazy(this.searchQuery,0);
      }


    }

    onCancel(ev) {
    this.searchQuery = " ";
      this.customers = [];
      this.searchCustomersLazy(this.searchQuery,0);
    ev.target.value = '';
  }


    arrayUnique(array) {
	    var a = array.concat();
	    for(var i=0; i<a.length; ++i) {
	        for(var j=i+1; j<a.length; ++j) {
	            if(a[i].id === a[j].id)
	                a.splice(j--, 1);
	        }
	    }

	    return a;
	}


	getRandomInt() { // 0 or 1 dummy data
	  return Math.round(Math.random()) ;
	}

	editCustomerAccess(customer){

	}



	checkActive(customer){
		let temp = [false,true];
		return 	temp[customer.isActive];
	}

	addCustomer(){
		this.nav.push(WebstoreUserAddPage);
	}

	updateCustomerCred(customer){
		//if(customer.userStatus == 1){
			this.gVLogger.log("Update Customer Credentials");
			let modal = this.modalController.create(WebstoreUserAddPopup,{ customer: customer ,button:"UPDATE" });
			modal.onDidDismiss(data => {
				if(data!=null){
					customer = data.customer;
				}
			});
			modal.present();

	}

	toggleStatus(customer){
		let tempState = customer.userStatus;
		let tempStateInverse;
		if(tempState == 0){
			tempStateInverse = 1;
		}else{
			tempStateInverse = 0;
		}

		if (tempState == true) {
			tempState = 1
		}else{
			tempState = 0
		}


		let body = {
	        customerId: customer.id,
	        changeBy: this.cartManager.getSalesPerson().id,
	        userName: customer.userName,
	        password: customer.password,
	        userStatus: tempState,
	        userLastName: customer.userLastName ,
	        userFirstName: customer.userFirstName,
	        userEmail: customer.email,
	        userPhone: customer.phone,
	        userRole: 2
	    };

		SpinnerDialog.show(this.msgManager.getLoadingMsg());
		this.api.post("customers/editUserByCustomer",body).map(res => res.json()).subscribe(result =>{
		if(result.status == "200"){
		this.toastMsg(result.message);
		}else if(result.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
            this.nav.setRoot(LoginPage);
          }else{
			this.toastMsg(result.message);
			customer.userStatus = tempStateInverse;
		}
		SpinnerDialog.hide();
		}, error =>{
		this.toastMsg(this.msgManager.getWentWrongMsg());
		customer.userStatus = tempStateInverse;
		SpinnerDialog.hide();
		});



	}


toastMsg(msg){
    let taost = this.toastController.create({
        message: msg,
        duration: 3000
    });
    taost.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/webstore-users/webstore-users.ts